import { gql } from '@apollo/client';

const createLetterTemplate = gql`
  mutation createLetterTemplate($input: LetterTemplateInput!) {
    createLetterTemplate(input: $input) {
      id
      name
      description
      content
      variables_used
      created_at
      updated_at
    }
  }
`;

export default createLetterTemplate;
